import { useState, useEffect } from 'react';
import api from '../api';
import BackButton from '../components/BackButton';
import { useI18n } from '../i18n/index.jsx';

export default function AdminIncomingInvoices() {
  const [invoices, setInvoices] = useState([]);
  const { t } = useI18n();
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [rejectReason, setRejectReason] = useState('');
  const [processing, setProcessing] = useState(false);

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    try {
      const { data } = await api.get('/invoices/in/admin/pending');
      setInvoices(data || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  async function approve() {
    if (!selected) return;
    setProcessing(true);
    try {
      await api.post(`/invoices/in/admin/approve/${selected.id}`);
      setSelected(null);
      await load();
    } catch (e) {
      alert(e.userMessage || 'Ошибка');
    } finally {
      setProcessing(false);
    }
  }

  async function reject() {
    if (!selected) return;
    if (!rejectReason.trim()) return alert('Укажите причину');
    setProcessing(true);
    try {
      await api.post(`/invoices/in/admin/reject/${selected.id}`, { reason: rejectReason.trim() });
      setRejectReason('');
      setSelected(null);
      await load();
    } catch (e) {
      alert(e.userMessage || 'Ошибка');
    } finally {
      setProcessing(false);
    }
  }

  if (loading) return <div className="page"><BackButton /><div className="loader">{t('common.loading')}</div></div>;

  return (
    <div className="page">
      <BackButton />
      <h1>📥 Входящие фактуры (админ)</h1>

      {selected && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.9)', zIndex: 100,
          display: 'flex', flexDirection: 'column', padding: 20,
          overflow: 'auto',
        }}>
          <div style={{ textAlign: 'right', marginBottom: 12 }}>
            <button className="btn" onClick={() => setSelected(null)}>✕ Закрыть</button>
          </div>

          {selected.image_data && (
            <img
              src={selected.image_data}
              alt="Invoice"
              style={{ maxWidth: '100%', maxHeight: '50vh', objectFit: 'contain', borderRadius: 8, marginBottom: 16 }}
            />
          )}

          <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 12, padding: 16 }}>
            <div style={{ marginBottom: 8 }}><b>Продавец:</b> {selected.seller_name || '—'}</div>
            <div style={{ marginBottom: 8 }}><b>NIP:</b> {selected.seller_nip || '—'}</div>
            <div style={{ marginBottom: 8 }}><b>Номер:</b> {selected.invoice_number || '—'}</div>
            <div style={{ marginBottom: 8 }}><b>Дата:</b> {selected.issue_date || '—'}</div>
            <div style={{ marginBottom: 8 }}><b>Netto:</b> {selected.net_amount} PLN</div>
            <div style={{ marginBottom: 8 }}><b>VAT:</b> {selected.vat_amount} PLN</div>
            <div style={{ marginBottom: 8 }}><b>Brutto:</b> {selected.gross_amount} PLN</div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 12 }}>
              <button className="btn btn-primary" onClick={approve} disabled={processing}>
                {processing ? '⏳' : '✅ Одобрить'}
              </button>
              <button className="btn" onClick={reject} disabled={processing} style={{ background: 'rgba(239,68,68,0.3)' }}>
                {processing ? '⏳' : '❌ Отклонить'}
              </button>
            </div>

            <input
              type="text"
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Причина отклонения (если нужно)"
              style={{
                width: '100%', padding: 12, borderRadius: 8, marginTop: 8,
                border: '1px solid rgba(255,255,255,0.2)',
                background: 'rgba(255,255,255,0.05)', color: '#fff',
              }}
            />
          </div>
        </div>
      )}

      {invoices.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 32, background: 'rgba(255,255,255,0.05)', borderRadius: 12 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>📥</div>
          <p style={{ opacity: 0.7 }}>Нет ожидающих фактур</p>
        </div>
      ) : (
        <div className="list">
          {invoices.map(inv => (
            <div key={inv.id} className="card" onClick={() => setSelected(inv)}>
              <div className="row">
                <strong>{inv.invoice_number || 'Без номера'}</strong>
                <span style={{ fontSize: 12, opacity: 0.7 }}>#{inv.id}</span>
              </div>
              <div className="row secondary">
                <span>{inv.seller_name || 'Продавец не указан'}</span>
                <span style={{ fontWeight: 'bold', color: '#10b981' }}>{inv.gross_amount?.toFixed(2)} PLN</span>
              </div>
              <div className="row secondary">
                <small>{inv.issue_date}</small>
                <small>NIP: {inv.seller_nip || '—'}</small>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
